import { useState, useEffect } from "react";
import { connect } from "react-redux";
import BasicAlert from './BasicAlert';
import $ from 'jquery';

function InvalidBalAlert({ invalidBal, page, onLinkClick }) {
  //State
  const [openAlert, setOpenAlert] = useState(false);

  //Method
  useEffect(() => {
    if(invalidBal) setOpenAlert(true);
    else setOpenAlert(false);
  }, [page, invalidBal]);

  return (
    <BasicAlert 
      openAlert={openAlert} 
      onClose={() => setOpenAlert(false)}
      title="Deal won't work properly!"
      content={
        <p class="font-sans text-base antialiased font-normal leading-relaxed text-white">
          The cash balance in <block class="text-yellow-300">{invalidBal?.date}</block> is lower than the 
          minimun cash balance by <block class="text-yellow-300">{invalidBal?.value?.toFixed(2)}$</block>.<br />
          Please modify&nbsp;
          <button class="text-yellow-300 font-sans underline"
            onClick={() => {
              onLinkClick();
              setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight);
                $("#LOC").fadeOut().fadeIn().fadeOut().fadeIn();
              }, 0);
            }}
          >
            Line of Credit Maximum Limit
          </button>.
        </p>
      }
    />
  )
}

const mapStateToProps = (state) => ({
  invalidBal: state.dealOffer?.debtPanel?.debtAndCashEngine?.invalidBal,
});

export default connect(mapStateToProps, null)(InvalidBalAlert);